   
export const SUMMARY_FIELDS = [
  { key: "Item_Code", label: "รหัสสินค้า", w: "15%", alignHeader: "center", align: "center", numeric: false, sortable: true },
  { key: "Item_Name", label: "ชื่อสินค้า", w: "30%", alignHeader: "center", align: "left", numeric: false, sortable: true },
  { key: "total_supplier", label: "จำนวนเจ้าหนี้", w: "15%", alignHeader: "end", align: "end", numeric: true, sortable: true },
  { key: "purchaseCount", label: "ครั้งที่ซื้อ", w: "15%", alignHeader: "end", align: "end", numeric: true, sortable: true },
  { key: "TotalQty", label: "จำนวนที่ซื้อ", w: "15%", alignHeader: "end", align: "end", numeric: true, sortable: true },
  { key: "Item_Total", label: "ยอดรวม (บาท)", w: "20%", alignHeader: "end", align: "end", numeric: true, sortable: true },
];

export const DETAIL_FIELDS = [
    {
        key: "Doc_Date",
        label: "วันที่",
        w: "12%",
        alignHeader: "center",
        align: "center",
        numeric: false,
    },
    {
        key: "Doc_No",
        label: "เลขที่เอกสาร",
        w: "8%",
        alignHeader: "center",
        align: "center",
        numeric: false,
        sortable: true,
    },    {
        key: "AP_Code",
        label: "รหัสเจ้าหนี้",
        w: "8%",
        alignHeader: "center",
        align: "center",
        numeric: false,
        sortable: true,
    },

        {
        key: "AP_Name",
        label: "ชื่อเจ้าหนี้",
        w: "16%",
        alignHeader: "center",
        align: "left",
        numeric: false,
        sortable: true,
    },
     
    {
        key: "Item_Qty",
        label: "จำนวนที่ซื้อ",
        w: "8%",
        alignHeader: "center",
        align: "end",
        numeric: true,
    },
    {
        key: "Item_Price_Unit",
        label: "ราคาต่อหน่วย",
        w: "10%",
        alignHeader: "center",
        align: "end",
        numeric: true,
    },
    {
        key: "Item_Discount",
        label: "ส่วนลด",
        w: "10%",
        alignHeader: "center",
        align: "end",
        numeric: true,
    },
    {
        key: "Item_Total",
        label: "ยอดรวม",
        w: "10%",
        alignHeader: "center",
        align: "end",
        numeric: true,
    }
    
];
